import React from 'react'

import { GatsbyImage, GatsbyImageProps } from 'gatsby-plugin-image'

import { CustomizableComponent } from '@contracts/components/customizableComponent'
import { wpMediaItemType } from '@contracts/wp/wpMedia'

interface Props extends CustomizableComponent {
	image: wpMediaItemType
	altText: string
	loading?: 'eager' | 'lazy'
	options?: Omit<GatsbyImageProps, 'alt' | 'image'>
	draggable?: boolean
}

const Image: React.FunctionComponent<Props> = (props) => {
	const { image, altText, className, loading } = props

	const classNames = [className]

	if (image) {
		if (image.mimeType == 'image/svg+xml' && image.localFile) {
			return <img src={image.localFile.publicURL} alt={altText} className={className} />
		} else if (image.localFile && image.localFile.childImageSharp) {
			return (
				<GatsbyImage
					image={image.localFile.childImageSharp.gatsbyImageData}
					alt={altText}
					className={classNames.join(' ')}
					loading={loading}
					draggable={props.draggable ? props.draggable : true}
					{...props.options}
				/>
			)
		}
	}

	return null
}

Image.defaultProps = {
	loading: 'lazy',
}

export default Image
